import axios from 'axios'

export default class Colaborador {
  constructor (tokenBearer, url, id) {
    this.url = `${url}/api/unimed/compColaborador/${id}`
    this.urlUltimo = `${url}/api/unimed/compColaborador/ultima/${id}`
    this.urlPendetes = `${url}/api/unimed/compColaborador/pendentes/${id}`
    this.tokenBearer = tokenBearer
  }

  async getColaboradores (args) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getUltimoColaborador () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.urlUltimo,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getPendentesColaboradores () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.urlPendetes,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async putColaborador (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
